import styled from "styled-components";

const theme = {
  sungsim: "#2a3341",
  baseball: "#FFCC00",
};

export const KioskResStatus = styled.div`
  padding: 20px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  user-select: none;
  .content {
    height: calc(100% - 250px);
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
  }
  .pagination {
    margin-top: 0;
    gap: 10px;
    display: flex;
    list-style: none;
    padding: 0;
    &.baseball {
      li.active,
      li:hover:not(.disabled) {
        background: ${theme.baseball};
        border-color: ${theme.baseball};
        a {
          color: #000;
        }
      }
    }
    &.sungsim {
      li.active,
      li:hover:not(.disabled) {
        background: ${theme.sungsim};
        border-color: ${theme.sungsim};
      }
    }
    li {
      border-radius: 5px;
      transition: 0.3s;
      border: 3px solid #efefef;
      a {
        font-size: 22px;
        display: block;
        padding: 10px 15px;
        text-decoration: none;
      }
      &.disabled {
        background: #efefef;
        pointer-events: none;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .pagination {
      gap: 5px;
      li {
        width: 35px;
        a {
          font-size: 18px;
          padding: 0;
        }
      }
    }
    .content {
      height: calc(100% - 220px);
    }
  }
`;

export const DetailsUseInquiryModal = styled.div`
  position: fixed;
  z-index: 3000;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  .storageInfo {
    margin-top: 30px;
    width: 100%;
    height: calc(100% - 130px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
    > ul {
      width: 100%;
      > li {
        font-size: 20px;
        display: inline-block;
        width: calc(50% - 10px);
        border: 2px solid #000;
        padding: 5px;
        margin-bottom: 20px;
        border-radius: 10px;
        &:nth-child(odd) {
          margin-right: 20px;
        }
        .tit {
          display: inline-block;
          width: 120px;
        }
        .con {
          display: inline-block;
          width: calc(100% - 120px);
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    .storageInfo > ul > li {
      width: 100%;
      &:nth-child(odd) {
        margin-right: 0;
      }
    }
  }
`;
